import { useEffect, useState } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
// import { startLoginGoogle } from '../../store/slices/usuario';
// google auth
import GoogleLogin from 'react-google-login';
// types
import { Button } from '@mui/material';
import { RootState, AppDispatch } from '../../store/store';
import { setError, startLoginGoogle } from '../../store/slices/usuario';

// import logo_PIMU from "../../img/logo_pimu_color.png";

const Login = () => {

    const dispatch = useDispatch<AppDispatch>();

    const { error } = useSelector((state: RootState) => state.usuario);

    const [msg, setMsg] = useState('');

    useEffect(() => {
        if (error) {
            setMsg(error)
            const timer = setTimeout(() => {setMsg(''); dispatch(setError(''));}, 5000);
            return () => clearTimeout(timer);
        }
    }, [error, dispatch]);
  

    const clientId = process.env.REACT_APP_API;

    const responseGoogle = (response: object) => {
        // console.log(response);
        dispatch(startLoginGoogle(response));
    }

    return (
        <div className='auth'>
            <div className="container">
                {     
                    msg !== '' &&
                    <div 
                        className="alert alert-danger" 
                        role="alert" 
                        style={{
                            position: 'absolute', 
                            top: '30px',
                            right: '30px'
                        }}
                    >
                        {msg} 
                    </div>
                }

                

                <div className="row justify-content-center">
                    <div className="col-lg-8 col-xl-6">
                        <div 
                            className="card" 
                            style={{
                                boxShadow: '20px 20px 20px rgba(0, 0, 0, 0.3)',
                                background: 'rgba(0, 0, 0, 0.5)'  
                            }}
                        >
                            <div className="card-body text-center text-white my-5">

                                <h1 className='mb-5' style={{fontWeight: 'lighter'}}>
                                    Bienvenid@
                                </h1>

                                {/* <img src={logo_PIMU} alt="" width="200px"/> */}

                                {/* <h4 className='my-5' style={{fontWeight: 'lighter'}}>
                                    Programa de Inserción a la Matemática Universitaria
                                </h4> */}

                                <GoogleLogin
                                    clientId={`${clientId}`}
                                    render={(renderProps: any) => (
                                        <>
                                            <Button 
                                                variant="contained"
                                                onClick={renderProps.onClick} 
                                                disabled={renderProps.disabled}
                                            >
                                                Login
                                            </Button>
                                        </>
                                    )}
                                    buttonText="Login"
                                    onSuccess={responseGoogle}
                                    onFailure={responseGoogle}
                                    cookiePolicy={process.env.REACT_APP_GOOGLE_AUTH}
                                    isSignedIn={false}
                                    // hostedDomain={'uc.cl'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Login;
